import React, { useContext, useState, useEffect } from 'react'
import Cookies from 'js-cookie';


const AuthContext = React.createContext(null);


export function useAuth() {
    return useContext(AuthContext)
}

export default function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null)
    // const [loading, setLoading] = useState(false)
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const login = () => {
        setIsAuthenticated(true);
    };

    const logout = () => {
        setCurrentUser(null);
        Cookies.remove('userAccessToken');
        Cookies.remove('userEmail');
        Cookies.remove('userName');

    };

    function refresh() {
        return window.location.reload()
    }

    const updateData = (newData) => {
        setCurrentUser(newData);
    };


    useEffect(() => {
       
    },[currentUser])
  
    const value = {
        currentUser,
        // signup,
        isAuthenticated,
        login,
        logout,
        updateData,
        refresh,
    }
    return (
        <AuthContext.Provider value={value}>
            {/* {!loading  && children} */}
            {children}
        </AuthContext.Provider>
    )
}
